import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollCategory  {
    _originalTypeClassName = "zERP.BO.PayrollCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollCategory.translate = translateService;
}
this.Levels = [];
this.Id = null;
this.Name = null;
this.Code = null;
this.Description = null;
this.Months = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Code:any;
Description:any;
Months:any;
Levels:any;
static setLevels = ($this, items) => {
                if (items == null) items = [];
                if ($this.Levels == null) $this.Levels = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Levels.length > 0) {
                    Domain.PayrollCategory.removeLevels($this, $this.Levels[0]);
                }

                Domain.PayrollCategory.addManyLevels($this, copyItems);
            }
static addManyLevels = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollCategory.addLevels($this, items[i]);
                }
            }
static addLevels = ($this, item) => {
                if ($this.Levels == null) $this.Levels = [];
                if (item == null || $this.Levels.indexOf(item) > -1) return;
                $this.Levels.push(item);
if (item.Parent != $this) {
Domain.PayrollCategoryLevel.setParent(item, $this);
}
}
static addRangeLevels = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollCategory.addLevels($this, item));
            }
static removeLevels = ($this, item) => {
                if ($this == null || $this.Levels == null || $this.Levels.indexOf(item) === -1) return;
                var _index = $this.Levels.indexOf(item);
                $this.Levels.splice(_index, 1);
item.Parent = null;
}
static clearLevels = ($this) => { $this.Levels = null; }

static GetClassName(): any{return "PayrollCategory";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}